<template>
	<div ref="container" style="width: 100%; height: 100%;"></div>
</template>

<script>
import ViewerCountWidget from '@/widgets/ViewerCountWidget';
import FetchPoller from '@/FetchPoller';

function fakeViewerCount() {
	return Math.floor(Math.random() * 900) + 50;
}

export default {
	name: 'ViewerCountWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
		realData: { type: Boolean, default: false },
	},
	data() {
		return {};
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
		realData() { this._stopUpdates(); this._destroyWidget(); this._initWidget(); },
	},
	mounted() {
		this._initWidget();
	},
	beforeDestroy() {
		this._stopUpdates();
		this._destroyWidget();
	},
	methods: {
		async _initWidget() {
			this.widget = new ViewerCountWidget({ container: this.$refs.container });
			await this.widget.init({ settings: { ...this.settings } });

			if(this.realData) {
				await this._startRealPolling();
			} else {
				await this._startFakeUpdates();
			}
		},

		async _startFakeUpdates() {
			try {
				const channels = await this.$api.get('channels/widgets');
				if(!this.widget) return;
				// Build fake channel list with fake info so render shows something
				const fakeChannels = channels.map(c => ({ ...c, info: { numViewers: fakeViewerCount(), numLive: 1 } }));
				this.widget.setChannels(fakeChannels);
			} catch(e) { /* ignore */ }

			this._updateIntervalId = setInterval(() => {
				if(!this.widget) return;
				for(const chat of this.widget.chats)
					this.widget.setChannelInfo(chat.service_id, chat.token, { numViewers: fakeViewerCount(), numLive: 1 });
			}, 2000);
		},

		async _startRealPolling() {
			this._channelInfoPollers = new Map();

			const fetchChannels = async signal => {
				const channels = await this.$api.get('widget/preview/channels', {}, signal).catch(() => []);
				if(!this.widget) return;
				this.widget.setChannels(channels);

				const enabledKeys = new Set(channels.filter(c => c.status === 'enabled').map(c => `${c.service_id}:${c.token}`));
				for(const [key, p] of this._channelInfoPollers) {
					if(!enabledKeys.has(key)) { p.stop(); this._channelInfoPollers.delete(key); }
				}
				for(const c of channels) {
					if(c.status !== 'enabled') continue;
					const key = `${c.service_id}:${c.token}`;
					if(this._channelInfoPollers.has(key)) continue;
					const p = new FetchPoller(sig =>
						this.$api.get(`widget/preview/channels/${c.service_id}/${c.token}/info`, {}, sig)
							.then(info => this.widget?.setChannelInfo(c.service_id, c.token, info))
							.catch(() => {}),
						60 * 1000,
					);
					this._channelInfoPollers.set(key, p);
					p.start();
				}
			};

			this._channelPoller = new FetchPoller(fetchChannels, 5 * 60 * 1000);
			this._channelPoller.start();

			this._previewSubId = this.$socket.subscribe('preview', {
				reconnect: () => this._channelPoller?.start(),
				channelInfoUpdate: msg => this.widget?.setChannelInfo(msg.serviceId, msg.channelToken, { numViewers: msg.numViewers, numLive: msg.numLive }),
				channelCreated:       () => this._channelPoller?.start(),
				channelDeleted:       () => this._channelPoller?.start(),
				channelStatusChanged: () => this._channelPoller?.start(),
			});
		},

		_stopUpdates() {
			if(this._updateIntervalId) { clearInterval(this._updateIntervalId); this._updateIntervalId = null; }
			if(this._channelPoller) { this._channelPoller.stop(); this._channelPoller = null; }
			if(this._channelInfoPollers) { for(const p of this._channelInfoPollers.values()) p.stop(); this._channelInfoPollers = null; }
			if(this._previewSubId != null) { this.$socket.unsubscribe(this._previewSubId); this._previewSubId = null; }
		},

		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},

		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
		},
	},
};
</script>
